import clsx from 'clsx'
import { useState } from 'react'
import React from 'react'
import { Control, Controller } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'

import s from './styles.module.scss'

import { HousesInformationsFieldsFragment } from '../../../../../../lib/graphql'
import { Mixpanel } from '../../../../../../utils/Mixpanel'
import { NumberInputRange } from '../../../../../forms'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../../../../popover/Popover'
import { ISelectProposalForm } from '../../../modal-select-proposal.types'

const AdultsPicker = ({
  control,
  house,
}: {
  control: Control<ISelectProposalForm, any>
  house: Pick<HousesInformationsFieldsFragment, 'capacity'>
}) => {
  const intl = useIntl()
  const [isAdultsOpen, setIsAdultsOpen] = useState(false)

  const closeAdults = (open: boolean) => {
    if (open) {
      setIsAdultsOpen(true)
    } else {
      setTimeout(() => {
        setIsAdultsOpen(false)
      }, 50)
    }
  }

  return (
    <Popover onOpenChange={closeAdults} open={isAdultsOpen}>
      <Controller
        control={control}
        name='adults'
        rules={{
          required: intl.formatMessage({
            id: 'ui.AdultsPicker.incompleteField',
            defaultMessage: 'Champ incomplet',
          }),
        }}
        render={({ field, fieldState: { error } }) => {
          return (
            <>
              <PopoverTrigger
                className={s.dateAdultsPart}
                onClick={() => {
                  setIsAdultsOpen(!isAdultsOpen)
                  Mixpanel.track('Select number of adults')
                }}
                data-testid='adults-picker'
              >
                <p
                  className={clsx(s.containerValue, {
                    [s.error]: Boolean(error),
                  })}
                >
                  {isAdultsOpen ? (
                    '-'
                  ) : (
                    <FormattedMessage
                      id='ui.AdultsPicker.adultsNumber'
                      defaultMessage='{adults} pers.'
                      values={{ adults: field.value }}
                    />
                  )}
                </p>
              </PopoverTrigger>
              <PopoverContent>
                <div className={s.adultsModal}>
                  <NumberInputRange
                    label={
                      <FormattedMessage
                        id='ui.AdultsPicker.travellers'
                        defaultMessage='Voyageurs'
                      />
                    }
                    value={field.value ?? 5}
                    onChange={(value) => field.onChange(value)}
                    min={2}
                    max={house.capacity || 999}
                    textField={{
                      placeholder: intl.formatMessage({
                        id: 'ui.AdultsPicker.travellersNumber',
                        defaultMessage: 'Nombre voyageurs',
                      }),
                      className: s.numberInputRangeTextField,
                    }}
                    height={30}
                    adultPicker={true}
                  />
                </div>
              </PopoverContent>
            </>
          )
        }}
      />
    </Popover>
  )
}

export default AdultsPicker
